import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DealerProfile } from '@app/domain/model/dealer-profile';
import { QueryReportsService } from '../../query-reports.service';
import { ReportType } from '@app/domain/model/report-type';
import { TransactionReport } from './transaction-report';
import { UserAuthority } from '@app/domain/model/user-authority';
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Component({
  selector: 'app-query-reports-result-transaction',
  styleUrls: ['./query-reports-result-transaction.component.scss'],
  templateUrl: './query-reports-result-transaction.component.html',
})
export class QueryReportsResultTransactionComponent {

  @Input()
  profile: DealerProfile;

  @Input()
  report: TransactionReport;

  ReportType: typeof ReportType = ReportType;

  constructor(private activeModal: NgbActiveModal,
              private readonly queryReportsService: QueryReportsService,
              private authenticator: AuthenticationService) {
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  onExport() {
    this.queryReportsService.xls(this.getDealerId() ? this.profile.id : null);
  }

  onPrint() {
    this.queryReportsService.print(this.getDealerId() ? this.profile.id : null);
  }

  isPaq(): boolean {
    return this.report.purchaseType === ReportType.PAQ;
  }

  private getDealerId() {
    const executor = this.authenticator.getCurrentUser();
    return executor.hasAuthority(UserAuthority.DEALER_INFO) ? this.profile.id : null;
  }
}
